import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { useStores } from "../../use.store";
import { submitApplicationFeedBack } from "../../services/submitFeedback";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import { getInformationAsset } from "../../helpers";

export default function FeedbackPage() {
  const { mainStore } = useStores();
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [ticketId, setTicketId] = useState();
  const [isPostFeedbackSuccess, setIsPostFeedbackSuccess] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const ticketIdParam = queryParams?.get("ticketId");
    if (ticketIdParam) {
      setTicketId(ticketIdParam);
    }
  }, []);

  const handleSubmit = async () => {
    const resp = await submitApplicationFeedBack(
      mainStore.config.baseUrl,
      mainStore.config.email,
      mainStore.config.password,
      mainStore.config.adsignId,
      rating,
      feedback,
      "68aebc2890490b51b4d28daa",
      ticketId
    );
    setIsPostFeedbackSuccess(resp);
  };
  const navigate = useNavigate();

  const handleSkip = () => {
    navigate("/");
  };

  return (
    <Layout>
      <div
        className="flex flex-col w-full h-screen bg-white bg-cover bg-center bg-no-repeat bg-fixed overflow-y-auto bg-cover bg-[#F9F9F9]"
        style={{
          backgroundImage: `url(
              ${getInformationAsset(
                mainStore.config,
                mainStore.appBackground,
                "./assets/images/app-bg.png"
              )}
            )`,
        }}
      >
        <div className="bg-[#215732] px-[50px] py-[60px] text-start">
          <span className="text-2xl font-serif text-white leading-tight">
            {mainStore.formFeedbackTitle ?? " How was our service quality?"}
          </span>
        </div>
        {isPostFeedbackSuccess ? (
          <div className="h-full flex flex-col p-12 relative">
            <div className="flex justify-center gap-4 mb-8">
              <span className="text-[20px] text-black">
                {mainStore.formFeedbackThankYouMsg ??
                  "Your valuable feedback enables us to make further improvements"}
              </span>
            </div>

            {/* Additional Feedback Section */}
            <div className="flex flex-row w-full items-center justify-center mb-8">
              <img
                src={getInformationAsset(
                  mainStore.config,
                  mainStore.formFeedbackThankYouImg
                )}
                className="w-[180px] h-[180px]"
              />
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col gap-4">
              <button
                onClick={handleSkip}
                className={`w-full py-4 bg-[#A09200] text-white rounded-lg font-medium text-lg transition-colors`}
              >
                Back to Main
              </button>
            </div>
          </div>
        ) : (
          <div className="h-full flex flex-col p-12 relative">
            {/* Star Rating */}
            <div className="flex justify-center gap-4 mb-12">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  className="transition-transform hover:scale-110 focus:outline-none"
                >
                  <Star
                    size={48}
                    className={`transition-colors ${
                      star <= (hoveredRating || rating)
                        ? "fill-yellow-400 text-yellow-400"
                        : "fill-gray-200 text-gray-200"
                    }`}
                  />
                </button>
              ))}
            </div>

            {/* Additional Feedback Section */}
            <div className="mb-8">
              <h2 className="text-2xl font-serif text-gray-800 mb-4">
                {mainStore.formFeedbackFieldName ?? "Additional Feedback"}
              </h2>
              <textarea
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Comments..."
                className="w-full h-40 p-4 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-600 resize-none text-gray-700 placeholder-gray-400"
              />
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col gap-4">
              <button
                onClick={handleSubmit}
                disabled={!rating || !feedback}
                className={`w-full py-4 ${
                  rating && feedback
                    ? "bg-[#A09200] text-white"
                    : "bg-gray-300 text-gray-500"
                }  rounded-lg font-medium text-lg hover:bg-gray-400 hover:text-gray-700 transition-colors`}
              >
                Submit
              </button>
              <button
                onClick={handleSkip}
                className="w-full py-2 text-yellow-600 bg-white font-medium text-lg hover:text-yellow-700 transition-colors"
              >
                Skip
              </button>
            </div>
          </div>
        )}

        <div className="flex-1"></div>
      </div>
    </Layout>
  );
}
